import { createContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { dropListPerPage } from "../components/fragment/perpage/PerpageComp";

type perPageProps = { label: string; value: number };

type myContextProps = {
  collapse?: boolean;
  setCollapse?: () => void;
  sideMenuCollapse?: string;
  setSideMenuCollapse?: (param?: string) => void;
  logout?: boolean;
  setLogout?: (param?: any) => void;
  sessionEnd?: boolean;
  setSessionEnd?: (param?: any) => void;
  perPage?: perPageProps;
  setPerPage?: (param?: perPageProps) => void;
};

const defaultPerPage = dropListPerPage[2];

const ActionContext = createContext<myContextProps>({
  collapse: false,
  setCollapse: () => {},
  logout: false,
  setLogout: (param) => {},
  sessionEnd: false,
  setSessionEnd: (param) => {},
  sideMenuCollapse: "",
  setSideMenuCollapse: (param) => {},
  perPage: defaultPerPage,
  setPerPage: (param) => {},
});

export function ActionContextProvider(props: any) {
  const [collapseVal, setCollapseVal] = useState(false);

  const setCollapseValFunc = () => {
    setCollapseVal(!collapseVal);
  };

  const [logoutVal, setLogoutVal] = useState(false);
  const logoutFunc = (param?: any) => {
    setLogoutVal(param);
  };

  const [sessionVal, setSessionVal] = useState(false);
  const SessionFunc = (param?: any) => {
    setSessionVal(param);
  };

  const location = useLocation();
  const valDrop = location?.pathname;
  const [sideMenuCollapseVal, setSideMenuCollapseVal] = useState("");

  useEffect(() => {
    if (!sideMenuCollapseVal) {
      setSideMenuCollapseVal(valDrop);
    }
  }, []);

  const setSideMenuCollapseValFunc = (param?: string) => {
    setSideMenuCollapseVal(param as string);
  };

  const [perPageVal, setPerPageVal] = useState<perPageProps>(defaultPerPage);

  const setPerPageFunc = (param?: perPageProps) => {
    setPerPageVal(param as perPageProps);
  };

  const contextValue = {
    collapse: collapseVal,
    setCollapse: setCollapseValFunc,
    logout: logoutVal,
    setLogout: logoutFunc,
    sessionEnd: sessionVal,
    setSessionEnd: SessionFunc,
    sideMenuCollapse: sideMenuCollapseVal,
    setSideMenuCollapse: setSideMenuCollapseValFunc,
    perPage: perPageVal,
    setPerPage: setPerPageFunc,
  };

  return (
    <ActionContext.Provider value={contextValue}>
      {props?.children}
    </ActionContext.Provider>
  );
}

export default ActionContext;
